import { localStorageKeys } from '../../../constants';

export const getAccountInvitationSentKey = (manufacturerId: number) =>
  `${localStorageKeys.accountInvitationSent}-${manufacturerId}`;

export const getAccountInvitationSentData = (
  manufacturerId: number,
): { resourceKey: string; payload: any } | null => {
  const invitationSentItem = localStorage.getItem(
    getAccountInvitationSentKey(manufacturerId),
  );

  return invitationSentItem ? JSON.parse(invitationSentItem) : null;
};

export const setAccountInvitationSentInfoMessage = (
  resourceKey: string,
  payload: any,
  manufacturerId: number,
) => {
  const data = { resourceKey, payload };
  localStorage.setItem(
    getAccountInvitationSentKey(manufacturerId),
    JSON.stringify(data),
  );
};

export const clearAccountInvitationSentInfoMessage = (
  manufacturerId: number,
) => {
  localStorage.removeItem(getAccountInvitationSentKey(manufacturerId));
};
